module.exports = __webpack_public_path__ + "img/5.a34593bf.jpg";